import Form from "react-bootstrap/Form";
import "../../../../src/main.css";
import React, { useState } from "react";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "react-bootstrap/Button";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useDoctorSlots } from "pages/store";
import {
  get24HoursAgoTimeStamp,
  getFutureTimestamp,
  formatDate
} from "modules/utilities/utility";

function EngagementFilter(props) {
  const [startDate, setStartDate] = useState(new Date(Date.now() - 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const formattedStartDate = startDate ? formatDate(startDate) : null;
    const formattedEndDate = endDate ? formatDate(endDate) : null;
    props.setStartDateFilter && props.setStartDateFilter(formattedStartDate);
    props.setEndDateFilter && props.setEndDateFilter(formattedEndDate);
    props.setDates && props.setDates(startDate.toISOString(), endDate.toISOString());
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate(null);
  };
  const handleResetEndDate = () => {
    setEndDate(null);
  };

  // const formatDate = (date) => {
  //   return format(date, "dd-MM-yyyy");
  // };

  const handleClearData = () => {
    props.setClear && props.setClear(props.clear + 1);
    if (props.setDates) {
      const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      const twentyFourHoursLater = new Date(Date.now() + 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      props.setDates(twentyFourHoursAgo, twentyFourHoursLater);
    }
  };

  return (
    <>
      <Form onSubmit={handleFilterSubmit} className="data-filter">
        <div className="d-flex gap-2">
          <Form.Group>
            <div className="input-container mt-1">
              {startDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                dateFormat="dd-MM-yyyy"
                value={startDate ? formatDate(startDate) : ""}
                className="input-with-icon"
              />
              {startDate && (
                <span className="reset-icon" onClick={handleResetStartDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <div className="input-container mt-1">
              {endDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                dateFormat="dd-MM-yyyy"
                value={endDate ? formatDate(endDate) : ""}
              />
              {endDate && (
                <span className="reset-icon" onClick={handleResetEndDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <div className="d-flex gap-2">
            <Button variant="primary" className="mt-1" type="submit">
              Apply
            </Button>
            <Button
              variant="primary"
              className="mt-1"
              onClick={handleClearData}
            >
              Clear
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}

export default EngagementFilter;
